import some from "lodash/some"
import uniq from "lodash/uniq"

import { useUserStore } from "~/stores/userStore"

const PUBLIC_PATHS = ["/e-gramatas"]

const TEACHERS_PATHS = ["/mani-zurnali"]

const STUDENTS_PATHS = ["/mani-zurnali"]

const PRO_PLANS_PATHS = [
  // "/metodiskie-lidzekli",
  // "/darba-lapas",
  // "/video",
  // "/viedgramata",
  "/mani-zurnali",
  // "/viedtemas",
  "/progress",
]

const PLUS_PLAN_PATHS = [
  // "/darba-lapas",
  // "/video",
  // "/viedgramata",
  "/mani-zurnali",
  // "/viedtemas",
  "/progress",
]

const EXTRA_PATHS = ["/active-inspire"]

const ALL_SUPPORTED_PATHS = uniq(
  PUBLIC_PATHS.concat(TEACHERS_PATHS)
    .concat(STUDENTS_PATHS)
    .concat(PRO_PLANS_PATHS)
    .concat(PLUS_PLAN_PATHS)
    .concat(EXTRA_PATHS)
)

// Full pages access control is hear, it is responsible for client side
export default defineNuxtRouteMiddleware(async (to, _from) => {
  const { path } = to
  const userStore = useUserStore()
  userStore.initFromStorage()
  await userStore.asyncReloadOnce()
  const { current: currentUser } = userStore

  // For whitelisted and admin users everything is allowed
  if (
    currentUser?.whitelisted ||
    currentUser?.admin ||
    some(PUBLIC_PATHS, (publicPath) => path.startsWith(publicPath) || path === "/")
  ) {
    if (path !== "/") {
      userStore.upgradeNoticeVisible = false
    }
    return
  } else if (
    some(TEACHERS_PATHS, (teacherPath) => path.startsWith(teacherPath)) &&
    some(STUDENTS_PATHS, (studentsPath) => path.startsWith(studentsPath))
  ) {
    if (userStore.isTeacher && currentUser?.lessons_allowed_or_active_school) {
      userStore.upgradeNoticeVisible = false
      return
    }

    if (["mykoob", "eklase"].includes(currentUser?.provider || "") && userStore.isStudent) {
      userStore.upgradeNoticeVisible = false
      return
    }
  } else if (some(PRO_PLANS_PATHS, (proPlanPath) => path.startsWith(proPlanPath)) && currentUser?.plan === "pro") {
    userStore.upgradeNoticeVisible = false
    return
  } else if (some(PLUS_PLAN_PATHS, (plusPlanPath) => path.startsWith(plusPlanPath)) && currentUser?.plan === "plus") {
    userStore.upgradeNoticeVisible = false
    return
  } else if (path.startsWith("/active-inspire")) {
    // For active inspire case we can fail fast,
    // therefore has_active_inspire check is not inside upper level conditon, but is nested
    if (currentUser?.has_active_inspire) {
      userStore.upgradeNoticeVisible = false
      return
    }
  }

  // You dont have access to page!
  if (some(ALL_SUPPORTED_PATHS, (pathPrefix) => path.startsWith(pathPrefix))) {
    userStore.upgradeNoticeVisible = true
    return navigateTo("/")
  }
})
